import React from 'react';
import {
  Grid,
} from '@mui/material';
import Featured from './featured';
import styles from './styles';
import Subscribe from '../marketplace/subscribe';
import Footer from '../marketplace/footer';
import HydraulicsNavbar from '../ui/hydraulics/Navbar';
import Features from './features';
import LiveECD from './liveECD';

const Hydraulics = () => {
  const classes = styles();

  return (
    <Grid sx={{ overflowX: 'hidden' }}>
      <HydraulicsNavbar />
      <Grid
        className={classes.hydraulicsWrapper}
      >
        <Features />
        <Featured />
        <LiveECD />
        <Subscribe />
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Hydraulics;
